/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSigma: {
  name: 'sigma';
  data: string;
} = {
  name: 'sigma',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.555.771A.5.5 0 0 1 3 .5h10a.5.5 0 0 1 0 1H3.972l4.435 6.21a.5.5 0 0 1 0 .58L3.972 14.5H13a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.407-.79L7.386 8 2.593 1.29a.5.5 0 0 1-.038-.519Z" fill="currentColor"/></svg>`,
};
